<template>
  <AppWithLoading v-slot:default="{ loader }">
    <VCard class="dialog">
      <VCardTitle class="dialog-header justify-start mb-1 flex-column align-start">
        <img
          :src="require('@/assets/img/tarrif-change-warning.svg')"
          alt="warning"
          class="dialog-header__icon"
        >
        <VBtn
          class="v-btn__close"
          icon
          small
          absolute
          top
          right
          @click="$emit('close')"
        >
          <IconClose />
        </VBtn>
        <div class="dialog-header__text">
          {{ $t('tariffInactive') }}
        </div>
      </VCardTitle>
      <VCardText class="dialog-text">
        {{ $t('expiredTariffText') }}
      </VCardText>
      <slot name="btn">
        <VBtn
          class="v-btn__send mb-0"
          color="success"
          id="inviteBtn"
          @click="loader(() => redirectToUpgradePlan())"
        >
          {{ $t('expiredTariffButton') }}
        </VBtn>
      </slot>
    </VCard>
  </AppWithLoading>
</template>

<script>
import { paymentTabs, settingsTabs } from '@/enums';
import AppWithLoading from '@/components/AppWithLoading';
import IconClose from './SvgIcons/Close.vue';

export default {
  name: 'DialogExpiredTariff',
  components: {
    AppWithLoading,
    IconClose,
  },
  setup(props, { root: { $router } }) {
    async function redirectToUpgradePlan() {
      await $router.push({
        name: 'settings',
        params: { type: settingsTabs.PAYMENT, addType: paymentTabs.INFO },
      });
    }

    return {
      redirectToUpgradePlan,
    };
  },
};
</script>

<style scoped lang="scss">
.v-btn {
  &__send {
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.2px;
    margin-bottom: 30px;
  }
  &__close {
    top: 15px;
    right: 15px;
  }
}

.dialog {
  padding: 30px;
  border-radius: 8px !important;
  color: #212121 !important;
}

.dialog-header {
  font-weight: 400;
  font-size: 24px;
  line-height: 26px;
  padding: 0;
  &__icon {
    padding: 13px;
    background: rgba(234, 13, 13, 0.1);
    border-radius: 50%;
  }
  &__text {
    text-align: start;
    margin: 20px 0;
  }
}
.dialog-text {
  padding: 0;
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 19.6px;
  font-weight: 300;
}
</style>

<i18n locale="ru" lang="yaml">
  tariffInactive: Тариф закончился
  expiredTariffText: Для получения доступа к функциям Вашего тарифа необходимо внести оплату.
  expiredTariffButton: Оплатить тариф
</i18n>

<i18n locale="en" lang="yaml">
  tariffInactive:  Your tariff is inactive
  expiredTariffText: To gain access to all the functions of your tariff, you need to make a payment.
  expiredTariffButton: Pay the tariff
</i18n>

